module.exports = __webpack_public_path__ + "static/media/prog.969d75ba.png";